// extracted by mini-css-extract-plugin
export default {"container":"xl-z","bubbleNav":"yl-z","graphic":"zl-z","contact":"Al-z"};